import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgArrowUp = (props) => {
    const { color } = props;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7072 15.7072C19.3167 16.0977 18.6835 16.0977 18.293 15.7072L12.0001 9.41421L5.70711 15.7072C5.31658 16.0977 4.68342 16.0977 4.29289 15.7072C3.90237 15.3166 3.90237 14.6835 4.29289 14.293L11.293 7.29289C11.6835 6.90237 12.3166 6.90237 12.7072 7.29289L19.7072 14.293C20.0978 14.6835 20.0978 15.3166 19.7072 15.7072Z", fill: color }));
};
export default factorySvgIcon(SvgArrowUp);
//# sourceMappingURL=SvgArrowUp.js.map